import type { RouteRecordRaw } from 'vue-router'

/*
 * The routes of the design module (branch `design` owns src/design/**); router/index.ts spreads
 * them in. `/t/:tid/designs/:id/edit` — the editor, inside the signed-in shell. The screen
 * player (`/play`) is not a console route: it is its own page and bundle (`play.html`,
 * `src/player/`), which Caddy and the Vite servers serve for `/play`.
 */
export const designRoutes: RouteRecordRaw[] = [
    {
        path:      '/t/:tid/designs/:id/edit',
        name:      'design-editor',
        component: () => import('@/design/views/Editor.vue'),
        meta:      { requiresAuth: true },
    },
]
